module.exports = __webpack_public_path__ + "img/gift-box.8b1fdfee.png";